var Handlebars = require("../../../node_modules/.pnpm/handlebars@4.7.9_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(lookupProperty(depth0,"service"),"config_data"),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":2,"column":4},"end":{"line":12,"column":11}}})) != null ? stack1 : "");
},"1":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div id=\"config_edit_inputbox\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,lookupProperty(helpers,"object_entries").call(alias1,lookupProperty(lookupProperty(depth0,"service"),"config_data"),{"name":"object_entries","hash":{},"data":data,"blockParams":blockParams,"loc":{"start":{"line":4,"column":20},"end":{"line":4,"column":56}}}),{"name":"each","hash":{},"fn":container.program(2, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":4,"column":12},"end":{"line":10,"column":21}}})) != null ? stack1 : "")
    + "        </div>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"input-group\">\n                    <label for=\"embedded_bot_"
    + alias2(alias1(lookupProperty(blockParams[0][0],"0"), depth0))
    + "_edit\" class=\"modal-field-label\">"
    + alias2(alias1(lookupProperty(blockParams[0][0],"0"), depth0))
    + "</label>\n                    <input type=\"text\" name=\""
    + alias2(alias1(lookupProperty(blockParams[0][0],"0"), depth0))
    + "\" id=\"embedded_bot_"
    + alias2(alias1(lookupProperty(blockParams[0][0],"0"), depth0))
    + "_edit\" class=\"modal_text_input\"\n                      maxlength=1000 value=\""
    + alias2(alias1(lookupProperty(blockParams[0][0],"1"), depth0))
    + "\" />\n                </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"service"),{"name":"if","hash":{},"fn":container.program(0, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":1,"column":0},"end":{"line":13,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useBlockParams":true});